import styled from "styled-components";

const Section = styled.section`
  margin-bottom: 20px;
  width: 100%;
`;

export {
  Section
}